import React, { useEffect, useState } from 'react'
import { Table } from 'antd'
import styled from 'styled-components/macro'
import TableColumn from './tableColumn'
import { useDispatch, useSelector } from 'react-redux'
import { fetchSupplierProducts } from '../../../features/ReceiptingSlice'

const AddProductModal = ({ ordersToAdding, setOrdersToAdding }) => {
  const dispatch = useDispatch()
  const supplierProducts = useSelector(
    state => state.receipting.supplierProducts,
  )
  const [filteredProducts, setFilteredProducts] = useState([])
  useEffect(() => {
    const { venue: venueId, supplier: supplierId } = ordersToAdding
    dispatch(fetchSupplierProducts(venueId, supplierId))
  }, [])
  useEffect(() => {}, [supplierProducts])
  return (
    <div>
      <HelpCopy>
        Add a shopping-list product that wasn’t on this PO. This doesn’t change
        the catalogue price. Unavailable after the order is receipted or in
        credit workflow.
      </HelpCopy>
      <Table
        scroll={{
          scrollToFirstRowOnChange: true,
        }}
        dataSource={[ordersToAdding]}
        pagination={false}
        columns={TableColumn(
          supplierProducts,
          filteredProducts,
          setFilteredProducts,
          setOrdersToAdding,
        )}
        rowKey={ordersToAdding.supplier}
      />
    </div>
  )
}

export default AddProductModal

const HelpCopy = styled.p`
  margin: 0 0 12px;
  font-size: 13px;
  line-height: 1.45;
  color: #595959;
`
